


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import CardCost from "@/components/CardCost";

@Component({
  name: "SubscriptionItem",
  components: { CardCost },
})
export default class SubscriptionItem extends Vue {
  @Prop({ type: Object, required: true })
  public readonly subscriptionLevel!: SubscriptionLevel;

  @Prop({ type: String, required: true })
  public readonly selectedFeedSubscriptionLevelId!: string;

  @Prop({ type: String })
  public readonly purchaseSubscriptionProcessing!: string;

  @Prop({ type: Boolean, default: false })
  public readonly disabled!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly isGradient!: boolean;

  public handleClick() {
    if (this.disabled) return;
    this.$emit("subscribe", this.subscriptionLevel);
  }

  get cost() {
    const mainCurrency = getMainCurrencyCode();
    return this.subscriptionLevel.pricePackage?.costs.find(i => i.currency === mainCurrency)?.cost ?? 0;
  }
}
